import React from 'react';
import {usePagination} from './usePagination';
import './pagination.scss';
const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const getTotalRecordsMessage = () => {
    var startItem = (currentPage - 1) * 10 + 1;
    var endItem = Math.min(currentPage * 10, totalCount);
    return (
      <span className="pagination-text">{`Showing ${startItem} To ${endItem} Of ${totalCount} Entries`}</span>
    );
  };

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });
  if (currentPage === 0 || paginationRange.length < 1) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <div className="col-12">
      <div className="row">
        {totalCount && totalCount !== 0 && (
          <div className="col-md-4">{getTotalRecordsMessage()}</div>
        )}
        <div className="col-md-8">
          <ul className={`pagination ${className}`}>
            <li className={`page-item ${currentPage === 1 && 'disabled'}`}>
              {currentPage !== 1 && 'disabled' && (
                <a
                  className="page-link page-link-text"
                  aria-label="Previous"
                  onClick={onPrevious}
                >
                  <span aria-hidden="true">&laquo;</span>
                  <span class="sr-only">Previous</span>
                </a>
              )}
            </li>
            {paginationRange.map((pageNumber) => {
              return (
                // ${active}
                <li
                  className={`page-item ${
                    pageNumber === currentPage && 'active'
                  }`}
                  key={pageNumber}
                >
                  <a
                    className="page-link page-link-text"
                    onClick={() => onPageChange(pageNumber)}
                  >
                    {pageNumber}
                  </a>
                </li>
              );
            })}
            <li
              className={`page-item ${currentPage === lastPage && 'disabled'}`}
              key={currentPage}
            >
              {currentPage !== lastPage && 'disabled' && (
                <a
                  className="page-link page-link-text"
                  aria-label="Next"
                  onClick={onNext}
                >
                  <span aria-hidden="true">&raquo;</span>
                  <span className="sr-only">Next</span>
                </a>
              )}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
